// extracted by mini-css-extract-plugin
export default {"backdrop":"Backdrop_backdrop__2jREj","slideInFromTop":"Backdrop_slideInFromTop__evDI3"};